var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidwooddoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 15.75H15.7256",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00229 2.00001C7.14175 1.97745 6.28854 2.14928 5.51953 2.50001V8.50001C6.28854 8.14928 7.14175 7.97745 8.00229 8.00001C8.86283 7.97745 9.71604 8.14928 10.485 8.50001V2.50001C9.71604 2.14928 8.86283 1.97745 8.00229 2.00001V2.00001Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00229 10.75C7.14175 10.7275 6.28854 10.8993 5.51953 11.25V14H10.485V11.25C9.71604 10.8993 8.86283 10.7275 8.00229 10.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 15.75V0.25H12.6918V15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3115 10.25C11.6162 10.25 11.8632 10.0261 11.8632 9.75C11.8632 9.47386 11.6162 9.25 11.3115 9.25C11.0068 9.25 10.7598 9.47386 10.7598 9.75C10.7598 10.0261 11.0068 10.25 11.3115 10.25Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3119 9.75009L11.2043 9.79759C11.0694 9.859 10.919 9.88696 10.7683 9.87862C10.6176 9.87027 10.472 9.82593 10.3464 9.75009V9.75009C10.2207 9.67425 10.0752 9.6299 9.92447 9.62156C9.77379 9.61322 9.62335 9.64117 9.48845 9.70259L9.38086 9.75009",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidwooddoor);
export default __webpack_public_path__ + "static/media/solid wood door.e5dc6e69.svg";
export { ForwardRef as ReactComponent };